import * as Placeholder from '-/Custom/Placeholder';
import EntityFilter from '-/Entity/EntityFilter';
import { Link, Stack, useLocalSearchParams } from 'expo-router';
import BadgeList from '@/components/Badge/BadgeList';
import BadgeListItem, {
  BadgeListItemFragment,
} from '@/components/Badge/BadgeListItem';
import Item from '@/components/UI/PressableRow';
import { type FragmentOf, readFragment } from '@/gql/graphql';
import useHeaderBackButton from '@/hooks/useHeaderBackButton';

export default function BadgeHome() {
  const { eventId, teamId, personId } = useLocalSearchParams<{
    eventId?: string;
    teamId?: string;
    personId?: string;
  }>();

  const badgeAssigneesWhere = eventId
    ? { event_id: { _eq: eventId }, person_id: { _eq: personId } }
    : { team_id: { _eq: teamId }, person_id: { _eq: personId } };

  const entityId = personId || teamId;

  const headerLeft = useHeaderBackButton();

  return (
    <>
      <Stack.Screen options={{ title: 'Badges', headerLeft }} />
      <EntityFilter />
      <BadgeList
        eventId={eventId}
        teamId={teamId}
        badgeAssigneesWhere={badgeAssigneesWhere}
        renderItem={({
          item,
        }: {
          item: FragmentOf<typeof BadgeListItemFragment>;
        }) => {
          const badge = readFragment(BadgeListItemFragment, item);

          return (
            <Link
              href={
                entityId
                  ? {
                      pathname: '/organization/badge/[badgeId]/assignee',
                      params: { badgeId: badge.id, eventId, teamId, personId },
                    }
                  : {
                      pathname: '/organization/badge/[badgeId]',
                      params: { badgeId: badge.id, eventId },
                    }
              }
              asChild
            >
              <Item>
                <BadgeListItem fragment={item} />
              </Item>
            </Link>
          );
        }}
        ListEmptyComponent={
          <Placeholder.Container>
            <Placeholder.Text>No Assignable Badges</Placeholder.Text>
          </Placeholder.Container>
        }
      />
    </>
  );
}
